export const initialInteractionState: InteractiveState = {
  isOverDomLayer: false,
};

export enum InteractionType {
  Hovered = 'Hovered',
  OverDOMLayer = 'OverDOMLayer',
}

interface InteractiveState {
  hoveredNodeId?: string;
  isOverDomLayer: boolean;
}

export type SetHovered = {
  type: InteractionType.Hovered;
  payload: {
    hoveredNodeId?: string;
  };
};

export type SetOverDOMLayer = {
  type: InteractionType.OverDOMLayer;
  payload: {
    isOverDomLayer: boolean;
  };
};

type InteractiveAction = SetHovered | SetOverDOMLayer;

export const reducer = (state: InteractiveState, action: InteractiveAction): InteractiveState => {
  switch (action.type) {
    case InteractionType.OverDOMLayer: {
      return { ...state, ...action.payload };
    }
    case InteractionType.Hovered: {
      return { ...state, ...action.payload };
    }

    default:
      return state;
  }
};
